import React from 'react';
import { Link } from 'react-router-dom';
import { WarrantyTag } from '../ui/WarrantyTag';
import { buttonClasses } from '../../utils/buttonStyles';
const steps = [{
  title: 'Contact support',
  body: 'Share your order number and a short description or photo of the issue.'
}, {
  title: 'We confirm the defect',
  body: 'Our team reviews the claim against the applicable warranty terms.'
}, {
  title: 'Replacement ships',
  body: 'Covered defects are resolved with a replacement light per warranty terms.'
}];
export function PromiseSection() {
  return <section aria-labelledby="promise-title" className="border-y mf-hairline bg-navy" data-id="element-213" data-mp="3ckorxztw2okq">
      <div className="mx-auto max-w-site px-5 py-24 md:px-8 md:py-32" data-id="element-214" data-mp="37lvci1v1knhx">
        <div className="grid gap-14 lg:grid-cols-[1.2fr_1fr]" data-id="element-215" data-mp="33lbdesqwr9t5">
          <div data-id="element-216" data-mp="1w89oik0x4rxz">
            <p className="font-display text-lg uppercase tracking-[0.14em] text-titanium" data-id="element-217" data-mp="1w8rrdzi364ev">The MarineForce Promise</p>
            <h2 id="promise-title" className="mt-3 font-display text-5xl font-semibold uppercase leading-[0.92] md:text-6xl" data-id="element-218" data-mp="1s64uvlagzvbc">
              Built for the Elements. Backed by MarineForceLED.
            </h2>
            <p className="mt-6 max-w-xl text-xl text-white" data-id="element-219" data-mp="ffl85m3p3o6r">
              Professional-grade lighting deserves professional-grade support.
            </p>
            <p className="mt-4 max-w-xl text-titanium" data-id="element-220" data-mp="5igmrohobwr0">
              If a light arrives defective, or experiences a covered failure during its applicable warranty period,
              MarineForceLED provides a replacement according to its warranty terms. Accidental damage, misuse and normal
              wear are not covered.
            </p>
            <div className="mt-8 flex flex-col gap-3 text-sm" data-id="element-221" data-mp="3e04ozjv3p4d7">
              <div className="flex flex-wrap items-center gap-x-3 gap-y-1" data-id="element-222" data-mp="3ix3etq7qep5l">
                <span className="w-44 text-titanium/70" data-id="element-223" data-mp="34xvdaqo3j4y8">Every M1 PRO system</span>
                <WarrantyTag tier="oneYear" data-id="element-224" data-mp="34zyd22f1wcg5" />
              </div>
            </div>
            <div className="mt-10 flex flex-wrap gap-3" data-id="element-225" data-mp="39w5at7xamhn0">
              <Link to="/promise" className={buttonClasses('secondary')} data-id="element-226" data-mp="1fgzw95atn7b9">
                Our Promise
              </Link>
              <Link to="/warranty" className={buttonClasses('ghost')} data-id="element-227" data-mp="1ap844qc0otj0">
                Warranty details
              </Link>
            </div>
          </div>

          <ol className="relative space-y-10 border-l border-titanium/20 pl-8 lg:mt-12" data-id="element-228" data-mp="11ple10oqna59">
            {steps.map((s, i) => <li key={s.title} className="relative" data-id="element-229" data-mp="1yej78egub00b" data-mpi={i}>
                <span className="absolute -left-[45px] flex h-7 w-7 items-center justify-center rounded-full border border-marine bg-navy text-xs font-semibold text-marine" data-id="element-230" data-mp="1yd81i93u3i6k">
                  {i + 1}
                </span>
                <h3 className="font-display text-2xl font-semibold uppercase tracking-[0.04em]" data-id="element-231" data-mp="1kgcgrje802ao">{s.title}</h3>
                <p className="mt-1.5 text-titanium" data-id="element-232" data-mp="e00ry8xafwrr">{s.body}</p>
              </li>)}
          </ol>
        </div>
      </div>
    </section>;
}